export default function noop(...args: any[]) {}
export function asyncNoop(...args: any[]) {
  return Promise.resolve();
}
